import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { getPostAuthRoute } from '../utils/auth-routing';

/**
 * BE-804: гвард раздела по ключу права. Меню-гейтинг прячет пункт, но прямая ссылка
 * должна упираться в тот же запрет — иначе раздел открывается пустым или с 403.
 *
 * Ставится ПОСЛЕ ролевого гварда (adminGuard/accountingGuard): тот решает, чей это
 * контур вообще, а этот — доступен ли конкретный раздел внутри контура.
 */
export function permissionGuard(key: string): CanActivateFn {
  return (_route, state) => {
    const auth = inject(AuthService);
    const router = inject(Router);
    if (auth.can(key)) {
      return true;
    }

    const home = getPostAuthRoute(auth.role(), auth.authState().tokens?.business_status) ?? ['/auth'];
    // Уводить некуда: закрытый раздел и есть домашний для этой роли (бухгалтер без
    // права на счета). Редирект в самого себя закольцевал бы гварды, поэтому пускаем
    // и оставляем отказ бэкенду — он вернёт 403, экран покажет ошибку.
    if (state.url.startsWith(home.join('/'))) {
      return true;
    }
    return router.createUrlTree(home);
  };
}
